<template>
  <div class="container">
    
    <div class="title-box" >
      <div class="title">
        <img src="../assets/images/2025/p1_txt1.svg" alt="title" srcset="" />
      </div>
      <div class="date">
        <p>報名徵件時間</p><p class="date_p">04/01</p><p>06/30</p>
      </div>
    </div>
    <div class="dragon">
      <picture>
        <source srcset="../assets/images/2025/dragon_ph@2x.webp" media="(max-width:1024px)">
        <img src="../assets/images/2025/p1_img1@2x.webp" alt="" srcset="" />
      </picture>
    </div>
    <div class="earth">
      <img src="../assets/images/2025/p1_img2@2x.webp" alt="" srcset="" />
    </div>

    <div class="bg" >
      <img src="../assets/images/2025/bg@2x.webp" alt="card1_bg" srcset="" />
    </div>

    
    <!-- <div class="moblie-title-box" v-if="isMobile">
      <div class="title">
        <img
          src="../assets/images/moblie_title1.png"
          alt="moblie_title1"
          srcset=""
        />
      </div>
      <div class="date mobileDate">
        <img
          src="../assets/images/moblie_title2.svg"
          alt="moblie_title2"
          srcset=""
        />
      </div>
    </div>
    <div class="moblie-bg" v-if="isMobile">
      <img src="../assets/images/moblie_bg.png" alt="" srcset="" />
    </div> -->
  </div>

  <!-- <div class="fix-2023link">
    <a
      href="https://longterm.acerfoundation.org.tw/2023/"
      target="_blank"
      rel="noopener noreferrer"
      >龍騰微笑獎<br />2023</a
    >
  </div> -->
</template>

<script>
export default {
  name: "KeyVision",
  data() {
    return {
      isMobile: true,
    };
  },

  mounted() {
    this.onResize();
    this.widthSize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 1024;
    },
    widthSize() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_mixin.scss";
.container {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  // @media all and (max-width: 1024px) {
  //   background-image: url(../assets/images/moblie_bg.png);
  //   background-size: cover;
  //   background-position: center;
  // }
  @media all and (max-width: 1024px) {
    height: 92vh;
  }
  .bg {
    position: absolute;
    left: 0px;
    bottom: 0px;
    z-index: 0;

    @media (max-width: 1024px) {
      bottom: auto;
      top: 7%;
      left: -77%;
      width: 218%;
    }

    img {
      width: 100%;
    }
  }

  .title-box {
    position: absolute;
    z-index: 2;
    width: 30%;
    top: 14%;
    left: 35%;
    display: flex;
    flex-direction: column;

    @media (max-width: 1024px){
      width: 70%;
      left: 0;
      right: 0;
      margin: auto;
    }

    .title {
      display: flex;
      justify-content: center;

      img {
        width: 100%;
      }
    }

    .date {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 3vw;

      @media (max-width: 1024px) {
        flex-wrap: wrap;
        margin-top: 6vw;
      }

      @media (max-width: 550px) {
        margin-top: 9vw;
      }

      p{
        color: #fff;
        margin: 0;
        font-family: 'Noto Sans TC';
        font-size: 1.6vw;
        letter-spacing: 0.2em;

        @media (max-width: 1024px){
          font-size: 4vw;
        }

        @media (max-width: 550px){
          font-size: 6vw;
        }

        &:nth-of-type(1){
          margin-right: 6%;
          @media (max-width: 1024px){
            width: 100%;
            text-align: center;
            margin: 0;
            margin-bottom: 4%;
          }
        }

        &.date_p{
          position: relative;
          margin-right: 12%;

          @media (max-width:1024px) {
            margin-right: 24%;
          }

          &::before{
            content: "";
            position: absolute;
            top: 53%;
            left: 103%;
            width: 51%;
            height: 1px;
            background-color: #fff;

            @media (max-width:1024px) {
              left: 105%;
              width: 62%;
            }
          }
        }
      }
    }
  }

  .dragon {
    position: absolute;
    top: 2vw;
    left: -22vw;
    width: 77%;
    z-index: 1;

    @media all and (max-width: 1024px) {
      width: 85%;
      top: auto;
      left: 7vw;
      bottom: -27vw;
    }

    @media all and (max-width: 550px) {
      
      width: 100%;
      left: 1vw;
      
    }


    img {
      width: 100%;
    }
  }

  .earth{
    position: absolute;
    width: 36%;
    top: 43%;
    left: 31%;
    z-index: 1;

    @media (max-width: 1024px) {
      width: 67%;
      top: 41%;
      left: -2%;
      transform: rotateY(180deg) rotate(77deg);
    }

    @media (max-width: 550px) {
      width: 90%;
      top: 44%;
      left: -11%;
    }

    img{
      width: 100%;
    }
  }

  .moblie-bg {
    padding-top: 20.5vw;
    img {
      width: 100%;
    }
  }

  .moblie-title-box {
    position: absolute;
    z-index: 2;
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);

    .title {
      text-align: center;
      img {
        width: 100%;
      }
    }

    .date {
      text-align: center;

      &.mobileDate{
        img{
          padding-top: 15%;
        }
      }

      img {
        width: 100%;
      }
    }
  }
}

.fix-2023link {
  position: fixed;
  right: 3vw;
  bottom: 3vw;
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  width: 4vw;
  height: 4vw;
  border-radius: 50%;
  z-index: 99;
  background: linear-gradient(
    to bottom,
    rgba(251, 241, 185, 1) 10%,
    rgba(147, 178, 141, 1) 81%
  );

  @media all and (max-width: 1920px) {
    width: 5vw;
    height: 5vw;
  }
  @media all and (max-width: 1440px) {
    width: 5.5vw;
    height: 5.5vw;
  }

  @media all and (max-width: 1024px) {
    width: 10vw;
    height: 10vw;
  }

  @media all and (max-width: 500px) {
    width: 22vw;
    height: 22vw;
  }

  a {
    color: rgb(62, 90, 89);
    text-align: center;
    font-size: 0.65vw;
    letter-spacing: 0.1em;
    font-family: "Noto Sans TC";
    font-weight: 400;

    @media all and (max-width: 1920px) {
      font-size: 0.8vw;
    }

    @media all and (max-width: 1440px) {
      font-size: 0.9vw;
    }

    @media all and (max-width: 1024px) {
      font-size: 1.7vw;
    }

    @media all and (max-width: 500px) {
      font-size: 3.5vw;
    }
  }
}
</style>
